import { ggDecimal, ggUnit, relativeDate } from './ng-filters';

export var sharedModule = angular.module('gplans.shared', []).
filter('ggDecimal', ggDecimal).
filter('ggUnit', ggUnit).
filter('relativeDate', relativeDate);